// The backend accepts the same shape; the last segment is the secret.
const WEBHOOK_URL =
  /^https:\/\/hooks\.slack(?:-gov)?\.com\/services\/T[A-Z0-9]+\/B[A-Z0-9]+\/[A-Za-z0-9]+$/

export const SLACK_CHANNEL_NAME_MAX_LENGTH = 80

export const isValidSlackWebhookUrl = (value: string) =>
  WEBHOOK_URL.test(value.trim())
